import { createAsyncThunk } from "@reduxjs/toolkit";

import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { GetAllRole, CreateNewRole, UpdateRole, DeleteRole, AssignRole, GetAllEmployees } from "helpers/api_method";

export const getAllRoleList = createAsyncThunk("role/getAllRoleList", async () => {
    try {
        const response = await GetAllRole();
        return response.data;
    } catch (error) {
        return error;
    }
});
export const addNewRole = createAsyncThunk("role/addNewRole", async (event: any) => {
    try {
        const response = await CreateNewRole(event);
        toast.success("Role created Successfully", { autoClose: 2000 });
        return response.data;
    } catch (error) {
        toast.error("Role creation Failed", { autoClose: 2000 });
        return error;
    }
});
export const updateExistingRole = createAsyncThunk("role/updateExistingRole", async (event: any) => {
    try {
        const response = await UpdateRole(event.id, event);
        toast.success("Role updated Successfully", { autoClose: 2000 });
        return response.data;
    } catch (error) {
        toast.error("Role updated Failed", { autoClose: 2000 });
        return error;
    }
});
export const updateUserRole = createAsyncThunk("role/updateUserRole", async (event: any) => {
    try {
        const response = await AssignRole(event.role_id, event);
        toast.success("Role assigned Successfully", { autoClose: 2000 });
        return response.data;
    } catch (error) {
        toast.error("Role assign Failed", { autoClose: 2000 });
        return error;
    }
});
export const deleteExistingRole = createAsyncThunk("role/deleteExistingRole", async (event: any) => {
    try {
        const response = await DeleteRole(event.id);
        toast.success("Role deleted Successfully", { autoClose: 2000 });
        return response.data;
    } catch (error) {
        toast.error("Role deletion Failed", { autoClose: 2000 });
        return error;
    }
});

export const getAllRoleUsers = createAsyncThunk("designation/getAllRoleUsers", async () => {
    try {
        const response = await GetAllEmployees();
        return response.data;
    } catch (error) {
        return error;
    }
});